export default "__VITE_ASSET__AhG2n0gO__"